import React, { useState } from "react";
import { Icon } from "@iconify/react";
import CommonInputContainer from "./CommonInputContainer";

function CommonFreeTextInput({
  value,
  placeholder,
  onChange,
  label,
  error,
  onFocus,
  onBlur,
  className,
  type = "text",
}) {
  const [showPassword, setShowPassword] = useState(false);
  const isPassword = type === "password";
  const inputType = isPassword && showPassword ? "text" : type;

  return (
    <CommonInputContainer
      label={label}
      error={error && !value}
      className={className}
    >
      <div className="relative">
        <input
          type={inputType}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder={placeholder}
          onFocus={onFocus}
          onBlur={onBlur}
          className={`w-full h-12 items-center px-4 border ${
            error && !value ? "border-red-600" : "border-[#DBDBDB]"
          } ${isPassword ? "pr-11" : ""} rounded-lg placeholder:text-[#A4B1C1] focus:outline-none`}
        />
        {isPassword ? (
          <button
            type="button"
            onClick={() => setShowPassword((visible) => !visible)}
            className="absolute right-3 top-1/2 -translate-y-1/2 text-[#6D7C94] hover:text-primary"
            aria-label={showPassword ? "Hide password" : "Show password"}
          >
            <Icon
              icon={
                showPassword ? "mdi:eye-off-outline" : "mdi:eye-outline"
              }
              className="text-xl"
            />
          </button>
        ) : null}
      </div>
    </CommonInputContainer>
  );
}

export default CommonFreeTextInput;
